module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-advanced-cash-flow-analysis-8e2c4b353e7454ad66a47aa02f16540f.png";